/* Brain Bumps Theme — brain-bumps.js */
(function() {
  'use strict';

  /* ── Helpers ── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }
  function money(cents) {
    var n = (cents || 0) / 100;
    var hasCents = Math.round(n * 100) % 100 !== 0;
    return '$' + n.toLocaleString('en-US', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: hasCents ? 2 : 0
    });
  }
  function subscribePrice(variant, sellingPlanId) {
    if (!variant) return 0;
    if (typeof variant.subscribe_price === 'number') return variant.subscribe_price;
    var allocs = variant.selling_plan_allocations || [];
    if (allocs.length && sellingPlanId) {
      for (var i = 0; i < allocs.length; i++) {
        if (String(allocs[i].selling_plan_id) === String(sellingPlanId)) return allocs[i].price;
      }
      return allocs[0].price;
    }
    if (allocs.length) return allocs[0].price;
    return Math.round(variant.price * 0.85);
  }

  /* ── Scroll reveal ── */
  function initReveal() {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.dataset.revealed = '1'; io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    qsa('[data-reveal]').forEach(function(el) {
      if (el.dataset.revealed !== '1') {
        el.dataset.revealed = '0';
        io.observe(el);
      }
    });
    // Immediately reveal above-fold
    requestAnimationFrame(function() {
      qsa('[data-reveal][data-revealed="0"]').forEach(function(el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.dataset.revealed = '1';
      });
    });
  }

  /* ── Sticky nav ── */
  function initNav() {
    var nav = qs('.bb-nav');
    if (!nav) return;
    function onScroll() {
      nav.classList.toggle('scrolled', window.scrollY > 24);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile nav drawer (focus trap + inert background) ── */
  function initDrawer() {
    var burger = qs('#bb-nav-burger');
    var drawer = qs('#bb-drawer');
    var backdrop = qs('#bb-drawer-backdrop');
    var closeBtn = qs('#bb-drawer-close');
    if (!burger || !drawer) return;
    var lastFocus = null;
    var inertTargets = [];

    function getFocusable(root) {
      return qsa('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])', root)
        .filter(function(el) { return !el.hasAttribute('disabled') && el.offsetParent !== null; });
    }

    function setBackgroundInert(on) {
      if (on) {
        inertTargets = qsa('main, .bb-nav, .bb-announcement, .bb-footer, #bb-sticky-bar, #bb-cart-notification')
          .filter(function(el) { return el && !drawer.contains(el); });
        inertTargets.forEach(function(el) {
          el.setAttribute('inert', '');
          el.setAttribute('aria-hidden', 'true');
        });
      } else {
        inertTargets.forEach(function(el) {
          el.removeAttribute('inert');
          el.removeAttribute('aria-hidden');
        });
        inertTargets = [];
      }
    }

    function setOpen(open) {
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      if (open) {
        lastFocus = document.activeElement;
        drawer.hidden = false;
        if (backdrop) backdrop.hidden = false;
        setBackgroundInert(true);
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            document.body.classList.add('bb-drawer-open');
            var closeFocus = qs('#bb-drawer-close', drawer);
            if (closeFocus) closeFocus.focus();
          });
        });
      } else {
        document.body.classList.remove('bb-drawer-open');
        setBackgroundInert(false);
        setTimeout(function() {
          if (!document.body.classList.contains('bb-drawer-open')) {
            drawer.hidden = true;
            if (backdrop) backdrop.hidden = true;
          }
        }, 350);
        (lastFocus || burger).focus();
      }
    }

    on(burger, 'click', function() { setOpen(true); });
    on(closeBtn, 'click', function() { setOpen(false); });
    on(backdrop, 'click', function() { setOpen(false); });
    document.addEventListener('keydown', function(e) {
      if (!document.body.classList.contains('bb-drawer-open')) return;
      if (e.key === 'Escape') {
        setOpen(false);
        return;
      }
      if (e.key !== 'Tab') return;
      var focusable = getFocusable(drawer);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  /* ── Nav dropdown disclosure ── */
  function initNavDropdown() {
    var dd = qs('.bb-nav-dd');
    if (!dd) return;
    var trigger = qs('.bb-nav-dd-trigger', dd);
    var menu = qs('.bb-nav-dd-menu', dd);
    if (!trigger || !menu) return;

    function setExpanded(open) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      dd.classList.toggle('bb-nav-dd--open', open);
    }

    on(trigger, 'click', function() {
      setExpanded(trigger.getAttribute('aria-expanded') !== 'true');
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') {
        setExpanded(false);
        trigger.focus();
      }
    });
    document.addEventListener('click', function(e) {
      if (!dd.contains(e.target)) setExpanded(false);
    });
  }

  /* ── FAQ accordion ── */
  function initFAQ() {
    qsa('.bb-faq-item').forEach(function(item) {
      var trigger = qs('.bb-faq-trigger', item);
      var panel = qs('.bb-faq-body', item);
      if (!trigger) return;
      if (panel && !item.classList.contains('open')) panel.hidden = true;
      on(trigger, 'click', function() {
        var isOpen = item.classList.contains('open');
        qsa('.bb-faq-item.open').forEach(function(o) {
          o.classList.remove('open');
          var t = qs('.bb-faq-trigger', o);
          var p = qs('.bb-faq-body', o);
          if (t) t.setAttribute('aria-expanded', 'false');
          if (p) p.hidden = true;
        });
        if (!isOpen) {
          item.classList.add('open');
          trigger.setAttribute('aria-expanded', 'true');
          if (panel) panel.hidden = false;
        }
      });
    });
  }

  /* ── Ingredient tabs (APG pattern) ── */
  function initIngTabs() {
    qsa('.bb-ing-tabs').forEach(function(container) {
      var tabs = qsa('.bb-ing-tab', container);
      var panels = qsa('.bb-ing-panel', container.closest('.bb-ing-section') || document);

      function activate(tab, focusTab) {
        var target = tab.dataset.target;
        tabs.forEach(function(t) {
          var selected = t === tab;
          t.className = t.className.replace(/active--\w+/g, '').trim();
          if (selected) t.classList.add('active--' + (t.dataset.color || 'blue'));
          t.setAttribute('aria-selected', selected ? 'true' : 'false');
          t.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(function(p) {
          var on = p.dataset.panel === target;
          p.classList.toggle('active', on);
          p.hidden = !on;
        });
        if (focusTab) tab.focus();
      }

      tabs.forEach(function(tab, index) {
        on(tab, 'click', function() { activate(tab, false); });
        on(tab, 'keydown', function(e) {
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(index + 1) % tabs.length];
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(index - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') next = tabs[0];
          else if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) {
            e.preventDefault();
            activate(next, true);
          }
        });
      });
    });
  }

  /* ── Product page ── */
  window.BrainBumps = window.BrainBumps || {};

  window.BrainBumps.initProduct = function(config) {
    var sectionId = config.sectionId;
    var sellingPlanId = config.sellingPlanId;
    var variants = config.variants || [];

    // Prefer the section form id; fall back if Liquid left a literal id attribute.
    var form = qs('#product-form-' + sectionId)
      || qs('form[data-type="add-to-cart-form"]')
      || qs('form.shopify-product-form');
    if (!form) return;

    // State — trust the server-rendered selection (Liquid checks current_variant)
    var checkedRadio = qs('input[name="id"]:checked', form);
    var activeVariantId = checkedRadio ? parseInt(checkedRadio.value, 10)
      : (variants[0] ? variants[0].id : null);
    var purchaseType = 'subscribe'; // default

    // Elements
    var variantCards = qsa('.bb-variant-card', form);
    var toggleOnce = qs('.bb-toggle-btn[data-type="once"]', form);
    var toggleSubscribe = qs('.bb-toggle-btn[data-type="subscribe"]', form);
    var sellingPlanInput = qs('input[name="selling_plan"]', form);
    var mainPrice = qs('.bb-price-main', form.parentElement || document);
    var originalPrice = qs('.bb-price-original', form.parentElement || document);
    var savingsBadge = qs('.bb-price-savings-badge', form.parentElement || document);
    var perTablet = qs('.bb-per-tablet', form.parentElement || document);
    var atcPriceEl = qs('.bb-atc-price', form);
    var subscribeNote = qs('.bb-subscribe-note', form.parentElement || document);
    var stickyBar = qs('.bb-sticky-bar');
    var stickyPriceEl = qs('.bb-sticky-price-main', stickyBar || document);
    var addToCartBtn = qs('[data-atc-anchor]');

    // Gallery
    var galleryMain = qs('.bb-gallery-main img');
    var galleryContainer = qs('.bb-gallery-main');
    var thumbs = qsa('.bb-thumb');
    function selectThumb(thumb) {
      var url = thumb.dataset.imageUrl;
      var bg = thumb.dataset.bg;
      var alt = thumb.dataset.alt || '';
      if (galleryMain && url) {
        galleryMain.src = url;
        if (alt) galleryMain.alt = alt;
      }
      if (galleryContainer && bg) galleryContainer.style.background = bg;
      thumbs.forEach(function(t) {
        var onThumb = t === thumb;
        t.classList.toggle('active', onThumb);
        t.setAttribute('aria-current', onThumb ? 'true' : 'false');
      });
    }
    thumbs.forEach(function(thumb) {
      on(thumb, 'click', function() { selectThumb(thumb); });
    });

    // Variant counting helper
    function getTabCount(variantTitle) {
      var match = (variantTitle || '').match(/^(\d+)/);
      return match ? parseInt(match[1], 10) : 1;
    }

    function getActiveVariant() {
      return variants.find(function(v) { return v.id === activeVariantId; }) || variants[0];
    }

    function updateVariantCards() {
      var isSubscribe = purchaseType === 'subscribe' && sellingPlanId;
      variantCards.forEach(function(card) {
        var once = parseInt(card.dataset.price, 10);
        var sub = parseInt(card.dataset.subscribePrice, 10);
        var tabs = parseInt(card.dataset.tabs, 10) || 1;
        if (isNaN(once)) return;
        var price = isSubscribe && !isNaN(sub) ? sub : once;
        var priceEl = qs('.bb-variant-price-val', card);
        var perEl = qs('.bb-variant-pertab', card);
        if (priceEl) priceEl.textContent = money(price);
        if (perEl) perEl.textContent = '$' + (price / tabs / 100).toFixed(2) + ' per tablet';
      });
    }

    function updatePriceDisplay() {
      var v = getActiveVariant();
      if (!v) return;
      var base = v.price; // cents
      var isSubscribe = purchaseType === 'subscribe' && sellingPlanId;
      var display = isSubscribe ? subscribePrice(v, sellingPlanId) : base;

      if (mainPrice) {
        mainPrice.innerHTML = '<span class="visually-hidden">' + (isSubscribe ? 'Sale price ' : 'Price ') + '</span>' + money(display);
      }
      if (originalPrice) {
        if (isSubscribe) {
          originalPrice.innerHTML = '<span class="visually-hidden">Regular price </span>' + money(base);
          originalPrice.style.display = '';
        } else {
          originalPrice.style.display = 'none';
        }
      }
      if (savingsBadge) {
        savingsBadge.style.display = isSubscribe ? '' : 'none';
      }
      var tc = getTabCount(v.title);
      if (perTablet) perTablet.textContent = '$' + (display / tc / 100).toFixed(2) + ' / tablet';
      if (atcPriceEl) atcPriceEl.textContent = money(display);
      if (stickyPriceEl) stickyPriceEl.textContent = money(display);
      updateVariantCards();
    }

    function setVariant(vid) {
      activeVariantId = vid;
      variantCards.forEach(function(card) {
        var isActive = card.dataset.variantId == vid;
        card.classList.toggle('active', isActive);
        var radio = qs('input[type="radio"]', card);
        if (radio) radio.checked = isActive;
      });
      updatePriceDisplay();
    }

    function setPurchaseType(type) {
      purchaseType = type;
      if (toggleOnce) {
        toggleOnce.classList.toggle('active', type === 'once');
        toggleOnce.setAttribute('aria-pressed', type === 'once' ? 'true' : 'false');
      }
      if (toggleSubscribe) {
        toggleSubscribe.classList.toggle('active', type === 'subscribe');
        toggleSubscribe.setAttribute('aria-pressed', type === 'subscribe' ? 'true' : 'false');
      }
      if (sellingPlanInput) {
        sellingPlanInput.value = (type === 'subscribe' && sellingPlanId) ? sellingPlanId : '';
      }
      if (subscribeNote) subscribeNote.style.display = type === 'subscribe' ? '' : 'none';
      updatePriceDisplay();
    }

    // Bind variant cards
    variantCards.forEach(function(card) {
      on(card, 'click', function() { setVariant(parseInt(card.dataset.variantId, 10)); });
    });

    // Bind purchase type toggle
    on(toggleOnce, 'click', function() { setPurchaseType('once'); });
    on(toggleSubscribe, 'click', function() { setPurchaseType('subscribe'); });

    // Qty buttons
    var qtyInput = qs('.bb-qty-input', form);
    on(qs('.bb-qty-btn--minus', form), 'click', function() {
      if (qtyInput) qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
    });
    on(qs('.bb-qty-btn--plus', form), 'click', function() {
      if (qtyInput) qtyInput.value = Math.min(9, parseInt(qtyInput.value, 10) + 1);
    });

    // Add to cart via AJAX
    function restoreSubmitBtn(btn) {
      var v = getActiveVariant();
      var price = v ? (purchaseType === 'subscribe' && sellingPlanId ? subscribePrice(v, sellingPlanId) : v.price) : 0;
      btn.disabled = false;
      btn.innerHTML = 'Add to Cart — <span class="bb-atc-price">' + money(price) + '</span>';
    }
    on(form, 'submit', function(e) {
      e.preventDefault();
      var submitBtn = qs('[type="submit"]', form);
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding...'; }
      var data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: data })
        .then(function(r) { return r.json(); })
        .then(function(item) {
          // Update cart count
          var countEls = qsa('.bb-cart-count');
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              countEls.forEach(function(el) { el.textContent = cart.item_count; });
              qsa('.bb-cart-link').forEach(function(link) {
                var n = cart.item_count;
                link.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
              });
            });
          // Show notification
          var notif = qs('#bb-cart-notification');
          var notifItem = qs('#bb-cart-notification-item');
          if (notif) {
            if (notifItem) notifItem.textContent = item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : '');
            notif.hidden = false;
            clearTimeout(notif._bbHideTimer);
            var scheduleHide = function() {
              clearTimeout(notif._bbHideTimer);
              notif._bbHideTimer = setTimeout(function() { notif.hidden = true; }, 8000);
            };
            scheduleHide();
            notif.onmouseenter = function() { clearTimeout(notif._bbHideTimer); };
            notif.onmouseleave = scheduleHide;
            notif.onfocusin = function() { clearTimeout(notif._bbHideTimer); };
            notif.onfocusout = scheduleHide;
          }
          if (submitBtn) restoreSubmitBtn(submitBtn);
        })
        .catch(function() {
          if (submitBtn) restoreSubmitBtn(submitBtn);
          var notif = qs('#bb-cart-notification');
          var notifItem = qs('#bb-cart-notification-item');
          if (notif) {
            if (notifItem) notifItem.textContent = 'Could not add to cart. Please try again.';
            notif.hidden = false;
          }
        });
    });

    // Sticky bar visibility — show when ATC leaves view, hide once legal/footer is on screen
    if (stickyBar && addToCartBtn) {
      var atcInView = true;
      var hideForFooter = false;
      function syncSticky() {
        stickyBar.classList.toggle('visible', !atcInView && !hideForFooter);
      }
      function checkFooter() {
        hideForFooter = false;
        var legal = document.querySelector('.bb-footer-bottom');
        var footer = document.querySelector('.bb-footer');
        var target = legal || footer;
        if (target && target.getBoundingClientRect().top < window.innerHeight) {
          hideForFooter = true;
        }
        if (footer && footer.getBoundingClientRect().bottom <= window.innerHeight + 2) {
          hideForFooter = true;
        }
        syncSticky();
      }
      var stickyIO = new IntersectionObserver(function(entries) {
        atcInView = !!(entries[0] && entries[0].isIntersecting);
        syncSticky();
      }, { threshold: 0.1 });
      stickyIO.observe(addToCartBtn);
      var footerTick = false;
      window.addEventListener('scroll', function() {
        if (!footerTick) {
          footerTick = true;
          requestAnimationFrame(function() { footerTick = false; checkFooter(); });
        }
      }, { passive: true });
      checkFooter();
    }

    // Init defaults
    setVariant(activeVariantId);
    setPurchaseType(sellingPlanId ? 'subscribe' : 'once');
  };

  /* ── Home buy box — compact pack cards with a shared subscribe/one-time toggle.
        Each card is its own product form (no-JS fallback posts to /cart/add). ── */
  window.BrainBumps.initBuyBox = function(config) {
    var root = document.getElementById('bb-buybox-' + config.sectionId);
    if (!root) return;

    var cards = qsa('[data-pack-card]', root);
    var toggleWrap = qs('[data-pack-toggle]', root);
    var subnote = qs('[data-pack-subnote]', root);
    var hasPlans = !!toggleWrap;
    var purchaseType = hasPlans ? 'subscribe' : 'once';

    function updatePrices() {
      var isSub = purchaseType === 'subscribe' && hasPlans;
      cards.forEach(function(card) {
        var once = parseInt(card.dataset.price, 10);
        var sub = parseInt(card.dataset.subscribePrice, 10);
        var tabs = parseInt(card.dataset.tabs, 10) || 1;
        if (isNaN(once)) return;
        var price = isSub && !isNaN(sub) ? sub : once;
        var priceEl = qs('[data-pack-price]', card);
        var perEl = qs('[data-pack-pertab]', card);
        var compareEl = qs('[data-pack-compare]', card);
        if (priceEl) priceEl.textContent = money(price);
        if (perEl) perEl.textContent = '$' + (price / tabs / 100).toFixed(2);
        if (compareEl) compareEl.hidden = !(isSub && price < once);
        var planInput = qs('[data-pack-plan]', card);
        if (planInput) planInput.disabled = !isSub;
      });
      if (subnote) subnote.style.display = purchaseType === 'subscribe' ? '' : 'none';
    }

    function setPurchaseType(type) {
      purchaseType = type;
      if (toggleWrap) {
        qsa('.bb-toggle-btn', toggleWrap).forEach(function(btn) {
          var onBtn = btn.dataset.type === type;
          btn.classList.toggle('active', onBtn);
          btn.setAttribute('aria-pressed', onBtn ? 'true' : 'false');
        });
      }
      updatePrices();
    }

    if (toggleWrap) {
      qsa('.bb-toggle-btn', toggleWrap).forEach(function(btn) {
        on(btn, 'click', function() { setPurchaseType(btn.dataset.type); });
      });
    }

    // AJAX add-to-cart per card
    cards.forEach(function(card) {
      var form = qs('form', card);
      var btn = qs('[type="submit"]', card);
      if (!form || !btn) return;
      on(form, 'submit', function(e) {
        e.preventDefault();
        var prevLabel = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding...';
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function(r) { return r.json(); })
          .then(function(item) {
            fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
              qsa('.bb-cart-count').forEach(function(el) { el.textContent = cart.item_count; });
            });
            var notif = qs('#bb-cart-notification');
            var notifItem = qs('#bb-cart-notification-item');
            if (notif) {
              if (notifItem) notifItem.textContent = item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : '');
              notif.hidden = false;
              setTimeout(function() { notif.hidden = true; }, 4000);
            }
            btn.disabled = false;
            btn.textContent = 'Added ✓';
            setTimeout(function() { btn.textContent = prevLabel; }, 1800);
          })
          .catch(function() {
            btn.disabled = false;
            btn.textContent = prevLabel;
          });
      });
    });

    setPurchaseType(purchaseType);

    // On the mobile swipe rail, start with the featured (Most Popular) pack centered.
    var rail = qs('[data-pack-grid]', root);
    var featured = qs('.bb-pack-card--featured', root);
    if (rail && featured && rail.scrollWidth > rail.clientWidth + 10) {
      rail.scrollLeft = featured.offsetLeft - (rail.clientWidth - featured.offsetWidth) / 2;
    }
  };

  /* ── Accessibility widget ── */
  function initA11y() {
    var root = qs('#bb-a11y');
    if (!root) return;
    var trigger = qs('#bb-a11y-trigger', root);
    var panel = qs('#bb-a11y-panel', root);
    var closeBtn = qs('#bb-a11y-close', root);
    var html = document.documentElement;
    var KEY = 'bb-a11y';
    var state = { font: 0, contrast: false, underline: false, motion: false, readable: false, spacing: false, grayscale: false };

    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || '{}');
      Object.keys(state).forEach(function(k) {
        if (typeof saved[k] !== 'undefined') state[k] = saved[k];
      });
    } catch (e) {}

    function save() {
      try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
    }

    function apply() {
      html.classList.toggle('bb-a11y-contrast', !!state.contrast);
      html.classList.toggle('bb-a11y-underline', !!state.underline);
      html.classList.toggle('bb-a11y-motion', !!state.motion);
      html.classList.toggle('bb-a11y-readable', !!state.readable);
      html.classList.toggle('bb-a11y-spacing', !!state.spacing);
      html.classList.toggle('bb-a11y-grayscale', !!state.grayscale);
      html.style.fontSize = state.font ? (100 + state.font * 12.5) + '%' : '';
      qsa('[data-a11y-toggle]', root).forEach(function(btn) {
        var key = btn.getAttribute('data-a11y-toggle');
        var on = !!state[key];
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      save();
    }

    function setOpen(open) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      if (open) {
        var first = qs('[data-a11y-action], [data-a11y-toggle]', panel);
        if (first) first.focus();
      } else {
        trigger.focus();
      }
    }

    on(trigger, 'click', function() {
      setOpen(panel.hidden);
    });
    on(closeBtn, 'click', function() { setOpen(false); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !panel.hidden) setOpen(false);
    });
    document.addEventListener('click', function(e) {
      if (!panel.hidden && !root.contains(e.target)) setOpen(false);
    });

    qsa('[data-a11y-action]', root).forEach(function(btn) {
      on(btn, 'click', function() {
        var action = btn.getAttribute('data-a11y-action');
        if (action === 'font-up') state.font = Math.min(3, (state.font || 0) + 1);
        else if (action === 'font-down') state.font = Math.max(-1, (state.font || 0) - 1);
        else if (action === 'font-reset') state.font = 0;
        else if (action === 'reset') {
          state = { font: 0, contrast: false, underline: false, motion: false, readable: false, spacing: false, grayscale: false };
        }
        apply();
      });
    });

    qsa('[data-a11y-toggle]', root).forEach(function(btn) {
      on(btn, 'click', function() {
        var key = btn.getAttribute('data-a11y-toggle');
        state[key] = !state[key];
        apply();
      });
    });

    apply();
  }

  /* ── Boot ── */
  document.addEventListener('DOMContentLoaded', function() {
    initReveal();
    initNav();
    initDrawer();
    initNavDropdown();
    initFAQ();
    initIngTabs();
    initA11y();
  });

})();
